module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "角色名"
    },
    model: {
      value: (_vm.filters.roleName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "roleName", $$v)
      },
      expression: "filters.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": "",
      "AddButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.roles,
      "highlight-current-row": "",
      "border": "",
      "height": _vm.formHeight,
      "size": "mini"
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleName",
      "label": "角色名称",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "角色类型",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == '0') ? _c('span', [_vm._v("员工")]) : _c('span', [_vm._v("客户")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('table-setting-button', {
          attrs: {
            "btnCon": "赋予权限"
          },
          on: {
            "select-type": function($event) {
              return _vm.handlePermission(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('table-update-button', {
          on: {
            "select-type": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [10, 20, 30, 40, 50],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.type,
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formRole",
    attrs: {
      "model": _vm.formRole,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formRole.roleName),
      callback: function($$v) {
        _vm.$set(_vm.formRole, "roleName", $$v)
      },
      expression: "formRole.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择角色类型"
    },
    model: {
      value: (_vm.formRole.type),
      callback: function($$v) {
        _vm.$set(_vm.formRole, "type", $$v)
      },
      expression: "formRole.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "员工",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "客户",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formRole.remark),
      callback: function($$v) {
        _vm.$set(_vm.formRole, "remark", $$v)
      },
      expression: "formRole.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "授予权限",
      "visible": _vm.permissionVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.permissionVisible = $event
      }
    }
  }, [_c('el-tree', {
    ref: "webTree",
    attrs: {
      "data": _vm.dataPer,
      "show-checkbox": "",
      "default-expand-all": "",
      "node-key": "permissionId",
      "highlight-current": "",
      "props": _vm.defaultProps,
      "default-checked-keys": _vm.checkPer
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitPermission.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-459991f4"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sysManage/Role.vue
// module id = 1906
// module chunks = 1